export { default as AI } from './ai.svg'
export { default as CALENDAR } from './calendar.svg'
export { default as CCTV } from './cctv.svg'
export { default as CLOCK } from './clock.svg'
export { default as COMMENT } from './comment.svg'
export { default as DOCTOR } from './doctor.svg'
export { default as DOCTOR_SMALL } from './doctor_16.svg'
export { default as DOWNLOAD } from './download.svg'
export { default as EYE } from './eye.svg'
export { default as HOSPITAL_ASSESSMENT_CERTIFIED } from './hospital-assessment-certified.svg'
export { default as MONEY } from './money.svg'
export { default as NEW_BADGE } from './new-badge.svg'
export { default as REALMODEL } from './realmodel.svg'
export { default as RECEIPT_CERTIFIED } from './receipt-certified.svg'
export { default as RESERVATION } from './reservation.svg'
export { default as SMILE } from './smile.svg'
export { default as STAR } from './star.svg'
export { default as SUB_ARROW } from './sub-arrow.svg'
export { default as THUMB_UP } from './thumb-up.svg'
export { default as TREATMENT_SUMMARY_CONCERN } from './treatment-summary-concern.svg'
export { default as TREATMENT_SUMMARY_CYCLES } from './treatment-summary-cycles.svg'
export { default as TREATMENT_SUMMARY_NUMBERS } from './treatment-summary-numbers.svg'
export { default as TREATMENT_SUMMARY_TIMES } from './treatment-summary-times.svg'
export { default as FLAG_CIRCLE_KR } from './flag-circle-kr.svg'
export { default as FLAG_CIRCLE_JP } from './flag-circle-jp.svg'
export { default as MULTIPLE_PHOTOS } from './multiple-photos.svg'
export { default as NAVBAR_COLUMN_ON } from './navbar-column-on.svg'
export { default as NAVBAR_COLUMN_OFF } from './navbar-column-off.svg'
export { default as WRITE } from './write.svg'
export { default as NOTICE } from './notice.svg'
export { default as TELEPHONE } from './telephone.svg'
export { default as BEST_CATEGORY } from './best-category.svg'
export { default as ASK_DOCTOR_CATEGORY } from './ask-doctor-category.svg'
export { default as FREE_TALK_CATEGORY } from './free-talk-category.svg'
export { default as HOSPITAL_QUESTION_CATEGORY } from './hospital-question-category.svg'
export { default as PLASTIC_SURGERY_QUESTION_CATEGORY } from './plastic-surgery-question-category.svg'
export { default as REVIEWS_CATEGORY } from './reviews-category.svg'
export { default as MEDICAL_TIP } from './medical-tip.svg'
export { default as DOCTOR_CATEGORY } from './doctor-category.svg'
export { default as REGION_CATEGORY } from './region-category.svg'
export { default as LOCKED } from './locked.svg'
export { default as VIEWS } from './views.svg'
